import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import i18n from './i18n';
import i18nServerError from './i18nServerError';
import LocaleContext from './LocaleContext';

var LocaleProvider = function LocaleProvider(_ref) {
  var _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'en' : _ref$lang,
      i18nServerErrorProp = _ref.i18nServerError,
      children = _ref.children;
  var localeProps = useMemo(function () {
    return {
      lang: lang,
      i18n: i18n(lang),
      i18nServerError: i18nServerErrorProp || i18nServerError(lang)
    };
  }, [lang, i18nServerErrorProp]);
  return _jsx(LocaleContext.Provider, Object.assign({
    value: localeProps
  }, {
    children: children
  }));
};

export default LocaleProvider;